import { toZonedTime } from 'date-fns-tz';

export const TIMEZONE_STORAGE_KEY = 'pref:timezone';

const getPreferredTimezone = (): string | null => {
  try {
    const value = localStorage.getItem(TIMEZONE_STORAGE_KEY);

    if (!value || value === 'undefined' || value === 'null') {
      return null;
    }

    return value;
  } catch {
    return null;
  }
};

/**
 * Returns the local time zone of the user's system.
 * @returns {string} The IANA time zone identifier.
 */
export const getLocalTimeZone = (): string =>
  // format = "IANA"
  // https://en.wikipedia.org/wiki/List_of_tz_database_time_zones
  getPreferredTimezone() || Intl.DateTimeFormat().resolvedOptions().timeZone;

export const getLocalDateTime = (): Date => {
  const timeZone = getLocalTimeZone(); // e.g., "Europe/Kiev"

  const now = new Date();

  const localDate = toZonedTime(now, timeZone);
  return localDate;
};
